// extracted by mini-css-extract-plugin
export default {"container":"modal_container__IxlHD","header":"modal_header__f0SFx","footer":"modal_footer__7vjtP","center":"modal_center__n8S9Q","body":"modal_body__+nueU"};